import { createFileRoute } from "@tanstack/react-router";
import { SkillEditPage } from "@client/components/tool-workshop/skill-edit-page";

function RouteComponent() {
  const { skillId } = Route.useParams();
  return <SkillEditPage key={skillId} />;
}

export const Route = createFileRoute("/_app/bots/skills/$skillId")({
  component: RouteComponent,
});
